// Register.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { FaEye, FaEyeSlash } from 'react-icons/fa';

function Register() {
  const [username, setUsername] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [errors, setErrors] = useState({});
  const [message, setMessage] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [termsAccepted, setTermsAccepted] = useState(false);
  const navigate = useNavigate();

  const validateEmail = (email) => {
    const re = /\S+@\S+\.\S+/;
    return re.test(email);
  };

  const validateForm = () => {
    const newErrors = {};

    if (!username) newErrors.username = 'Ad Zorunlu';
    if (!email) {
      newErrors.email = 'E Mail Zorunlu';
    } else if (!validateEmail(email)) {
      newErrors.email = 'Yanlış Mail Formatı';
    }
    if (!password) newErrors.password = 'Şifre Giriniz';
    if (!confirmPassword) newErrors.confirmPassword = 'Şifre Doğrulama Zorunlu';
    if (password !== confirmPassword) newErrors.confirmPassword = 'Şifreler Eşleşmiyor';
    if (!termsAccepted) newErrors.terms = 'Üyelik şartlarını kabul etmelisiniz';

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!validateForm()) return;

    try {
      const response = await axios.post('/api/register', {
        username: username,
        email: email,
        password: password,
      });

      console.log(response.data);

      // Store username in localStorage
      localStorage.setItem('username', username);

      // Show success message
      setMessage(`Kayıt başarılı, kullanıcı adı: ${username}. Girişe yönlendiriliyorsunuz`);

      // Redirect to login page after 2 seconds
      setTimeout(() => {
        navigate('/login');
      }, 2000);
    } catch (error) {
      console.error('Error:', error);

      if (error.response && error.response.data && error.response.data.error) {
        setErrors({ server: error.response.data.error });
      } else {
        setErrors({ server: 'Bir hata oluştu. Lütfen daha sonra tekrar deneyin.' });
      }
    }
  };

  return (
    <div className="register-page">
      {/* breadcrumb-section */}
      <div className="breadcrumb-section breadcrumb-bg">
        <div className="container">
          <div className="row">
            <div className="col-lg-8 offset-lg-2 text-center">
              <div className="breadcrumb-text">
                <p>Hesap Oluştur</p>
                <h1>Register</h1>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* end breadcrumb section */}

      <div className="row register-row">
        <div className="col-md-6">
          <form onSubmit={handleSubmit} noValidate>
            <div className="mb-3">
              <label htmlFor="username" className="form-label">Kullanıcı Adı</label>
              <input
                type="text"
                id="username"
                name="fullname"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                className={`form-control ${errors.username ? 'is-invalid' : ''}`}
                required
                autoComplete="name"
              />
              {errors.username && <div className="invalid-feedback">{errors.username}</div>}
            </div>

            <div className="mb-3">
              <label htmlFor="register-email" className="form-label">Email</label>
              <input
                type="email"
                id="register-email"
                name="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className={`form-control ${errors.email ? 'is-invalid' : ''}`}
                required
                autoComplete="email"
              />
              {errors.email && <div className="invalid-feedback">{errors.email}</div>}
            </div>

            <div className="mb-3 position-relative">
              <label htmlFor="register-password" className="form-label">Şifre</label>
              <input
                type={showPassword ? 'text' : 'password'}
                id="register-password"
                name="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className={`form-control ${errors.password ? 'is-invalid' : ''}`}
                required
                autoComplete="new-password"
              />
            </div>

            <div className="mb-3 position-relative">
              <label htmlFor="register-confirmPassword" className="form-label">Şifre Tekrar</label>
              <input
                type={showPassword ? 'text' : 'password'}
                id="register-confirmPassword"
                name="confirmPassword"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                className={`form-control ${errors.confirmPassword ? 'is-invalid' : ''}`}
                required
                autoComplete="new-password"
              />
              <button
                type="button"
                className="end-0 top-50 translate-middle-y border-0 bg-transparent"
                style={{ right: '10px', cursor: 'pointer' }}
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? <FaEyeSlash /> : <FaEye />}
              </button>
              {errors.confirmPassword && <div className="invalid-feedback">{errors.confirmPassword}</div>}
            </div>

            {/* Üyelik şartları */}
            <div className="mb-3">
              <div className="form-check">
                <input
                  type="checkbox"
                  className="form-check-input"
                  id="termsCheck"
                  checked={termsAccepted}
                  onChange={(e) => setTermsAccepted(e.target.checked)}
                />
                <label className="form-check-label" htmlFor="termsCheck">
                  <a href="/uyeliksozlesmesi" target="_blank" rel="noopener noreferrer">
                    Üyelik şartlarını
                  </a> okudum, kabul ediyorum
                </label>
              </div>
              {errors.terms && <div className="text-danger">{errors.terms}</div>}
            </div>

            <div className="mb-3">
              <button type="submit" className="btn btn-profile-register btn-lg">Kayıt Ol</button>
            </div>

            {message && <div className="alert alert-success">{message}</div>}
            {errors.server && <div className="alert alert-danger">{errors.server}</div>}
          </form>
        </div>
      </div>
    </div>
  );
}

export default Register;
